export const QUESTIONS_P = [
//P01
{
  q: '①乳癌は【40】～【60】歳代の閉経前後の女性に好発する．悪性腫瘍のうち女性の死亡数第【5】位，女性の罹患率第【1】位であり，死亡数・罹患率ともに【増加】傾向．',
  s: 'P01', ch: '乳癌',
},
//2
{
  q: '③乳癌では乳房の【無】痛性【腫瘤】(しこり)，乳頭からの【血性分泌】，腫瘍が周囲の組織を引き込むことによる乳房や乳頭の形の変化(【えくぼ】徴候，【ひきつれ】)がみられる．乳房の【C】領域に多くみられる．',
  s: 'P01', ch: '乳癌',
},
//4-6
{
  q: '④乳癌の診断',
  s: 'P01', ch: '乳癌',
  type: 'indent',
  rows: [
    { level: 0, text: 'まず問診，【視】診，【触】診' },
    { level: 1, text: '・【マンモグラフィ】：腫瘤(【spicula】)，微細硬化' },
    { level: 1, text: '・乳房【超音波】：腫瘤(乳腺【境界線】の断裂，【halo】)' },
    { level: 1, text: '・細胞診，組織診(【経皮】的生検)' },
    { level: 0, text: '診断がついたらさらに以下の検査を行う．' },
    { level: 1, text: '・広がり診断に乳房【MRI】' },
    { level: 1, text: '・全身検索：胸腹部【CT】(【肝】，【肺】転移の評価)' },
    { level: 1, text: '・【骨シンチグラフィ】(【骨】転移の評価)' },
  ]
},
{
  q: '⑤乳癌の治療',
  s: 'P01', ch: '乳癌',
  type: 'indent',
  rows: [
    { level: 0, text: '・外科的切除：乳房切除術，乳房温存術' },
    { level: 0, text: '・【放射線】療法' },
    { level: 0, text: '・化学療法：【アントラサイクリン】系，【タキサン】系' },
    { level: 0, text: '・【ホルモン】療法：ER(エストロゲンレセプター)陽性の場合に行う' },
    { level: 1, text: '閉経前であれば【タモキシフェン】，【LH-RHアゴニスト】' },
    { level: 1, text: '閉経後であれば【アロマターゼ阻害剤】など' },
    { level: 0, text: '・【分子標的】薬：HER2レセプター陽性の場合，トラスツズマブなど' },
  ]
},
{
  q: '⑥乳癌の治療方針',
  s: 'P01', ch: '乳癌',
  type: 'indent',
  rows: [
    { level: 0, text: '乳管内にとどまる非浸潤癌はstage0であり，基本的に転移しないため，外科的切除を行う．' },
    { level: 0, text: '・stageⅠ・Ⅱの場合はまず【外科的切除】を行ってから病理像より【薬物治療】を検討することが多い．' },
    { level: 0, text: '・stageⅢの場合は先に【薬物治療】で腫瘍を縮小させてから【外科的切除】を行うことが多い．' },
    { level: 0, text: '・遠隔転移のあるstageⅣでは主に【薬物治療】を行う．' },
  ]
},
{
  q: '②乳癌の外科的切除には，乳房切除術(【全摘】術)と乳房部分切除術(【温存】術)がある．部分切除の場合，残存する乳腺からの再発予防のため術後に【放射線】療法を行う．希望があれば，切除後に【再建】術を行う．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '③乳癌の腋窩リンパ節転移があれば【郭清】術を行う．術前に腋窩リンパ節転移がないと判断される場合は，【センチネルリンパ節生検】を行い，転移が確認できればやはり郭清術を行う．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '乳がんの外科切除に関して',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
  type: 'indent',
  rows: [
    {level:0,text:'④腫瘍組織の大きさ，【ER】(，PgR)発現の有無，【HER2】レセプター発現の有無を調べる．リンパ節転移の有無も調べる．以下の治療も考慮する．'},
    { level: 1, text: '腫瘍が大きい，リンパ節転移がある → 術後に【化学】療法を追加' },
    { level: 1, text: 'ER(やPgR)が陽性 → 【ホルモン】療法が有効' },
    { level: 1, text: 'HER2レセプター陽性 → 【分子標的】薬(【トラスツズマブ】)が有効' },
  ]
},
{
  q: '⑤閉経前の女性では，視床下部から分泌された【LH-RH】が下垂体からのLHを介して卵巣に働きかけて【エストロゲン】分泌を促し，このホルモンが乳癌の増殖に関与する．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '⑥閉経後の女性では，副腎で産生される【アンドロゲン】が【アロマターゼ】によりエストロゲンとなる．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '⑦閉経前の女性に対する乳癌のホルモン療法で用いる【LH-RHアゴニスト】は，投与後に一時的にエストロゲン分泌を増加させるが，ダウンレギュレーションによって結果的にエストロゲン分泌を低下させる．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '⑧エストロゲン作用を阻害する薬剤は，抗エストロゲン薬の【タモキシフェン】である．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '⑨閉経後の女性に対する乳癌のホルモン療法では【アロマターゼ阻害】薬を用いる．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
{
  q: '⑩乳癌の薬物療法では化学療法が基本となる．加えて【ER】陽性の場合はホルモン療法が，【HER2】レセプター陽性の場合は分子標的薬がそれぞれ有効である．',
  s: 'P01', ch: '乳癌の治療(Advanced study)',
},
    //P02
{
  q: '①乳房Paget病は乳管原発の腺癌が乳管内進展し，【乳頭】・【乳輪】へと表皮内進展をきたすことを特徴とする疾患で，軽微な【間質】浸潤を伴う．',
  s: 'P02', ch: '乳房Paget病',
},
{
  q: '②乳房Paget病の臨床像として，乳頭や乳輪の【発赤】・【びらん】がみられる．乳房内に腫瘤を触知【しない】．',
  s: 'P02', ch: '乳房Paget病',
},
{
  q: '③乳房Paget病は病理像で淡明な【Paget】細胞を認める．',
  s: 'P02', ch: '乳房Paget病',
},
{
  q: '④乳房Paget病の治療は【乳房切除術】．',
  s: 'P02', ch: '乳房Paget病',
},
{
  q: '①20～30歳代の若年に好発する乳房の良性結節病変を【線維腺腫】という．',
  s: 'P02', ch: '線維腺腫・乳腺症',
},
{
  q: '②30～50歳代に好発し，両側性の乳腺の硬結や囊胞を形成する病態を【乳腺症】という．',
  s: 'P02', ch: '線維腺腫・乳腺症',
},
//image 03
{
  q: '乳癌・線維腺腫・乳腺症の比較',
  s: 'P02', ch: '線維腺腫・乳腺症',
  type: 'grouped',
  categories: [
    {
      label: '好発年齢',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '40〜60歳代' },
          { term: '線維腺腫', desc: '【20】〜【30】歳代' },
          { term: '乳腺症', desc: '【30】〜【50】歳代' },
        ]
      }]
    },
    {
      label: '部位',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '片側性' },
          { term: '線維腺腫', desc: '【片】側性' },
          { term: '乳腺症', desc: '【両】側性' },
        ]
      }]
    },
    {
      label: '圧痛',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: 'なし' },
          { term: '線維腺腫', desc: '【なし】' },
          { term: '乳腺症', desc: '【あり】' },
        ]
      }]
    },
    {
      label: '境界',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '不明瞭' },
          { term: '線維腺腫', desc: '【明瞭】' },
          { term: '乳腺症', desc: '【不明瞭】' },
        ]
      }]
    },
    {
      label: '分泌物',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '血性' },
          { term: '線維腺腫', desc: 'なし' },
          { term: '乳腺症', desc: '【漿液】性，【乳汁】様' },
        ]
      }]
    },
    {
      label: '治療',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '(乳癌の治療参照)' },
          { term: '線維腺腫', desc: '基本的には経過観察．3cm以上は【切除】(【葉状腫瘍】との鑑別が難しい)' },
          { term: '乳腺症', desc: '経過観察' },
        ]
      }]
    },
    {
      label: 'マンモグラフィ',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: 'spicula，微細石灰化(【線】状，【分枝】))' },
          { term: '線維腺腫', desc: '境界明瞭な腫瘤，粗大石灰化(【ポップコーン】様)' },
          { term: '乳腺症', desc: '【円】形の微細石灰化' },
        ]
      }]
    },
    {
      label: '超音波',
      groups: [{
        label: '',
        rows: [
          { term: '乳癌', desc: '乳腺境界線の断裂，halo' },
          { term: '線維腺腫', desc: '境界明瞭な腫瘤' },
          { term: '乳腺症', desc: '(多彩)' },
        ]
      }]
    },
  ]
},
    {
  q: '①乳腺の間質が異常増殖し，腫瘍化したものを【葉状腫瘍】という．多くが【良】性腫瘍．',
  s: 'P02', ch: '葉状腫瘍',
},
{
  q: '②葉状腫瘍の臨床像として【増大】傾向がみられる．病理が【線維腺腫】と類似している．',
  s: 'P02', ch: '葉状腫瘍',
},
{
  q: '③葉状腫瘍は針生検にて診断し，治療は【外科的切除】．',
  s: 'P02', ch: '葉状腫瘍',
},
{
  q: '①乳管内に発生する乳頭状の良性腫瘍を【乳管内乳頭腫】という．',
  s: 'P02', ch: '乳管内乳頭腫',
},
{
  q: '②乳管内乳頭腫の臨床像として【血性分泌物】が特徴的．',
  s: 'P02', ch: '乳管内乳頭腫',
},
{
  q: '③乳管内乳頭腫は針生検にて診断する．治療は基本的に【経過観察】でよいが，癌との鑑別がつかない場合には【外科的切除】．',
  s: 'P02', ch: '乳管内乳頭腫',
},


]